// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-07-18T10:35:20Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Created by Marbes Consulting jaroslav.hudec@marbes.cz / 29.10.2018. Generated from cz.marbes.cgo.controller.NotifikaceController.
 */
export default class NotifikaceApi {
    /**
     * 
     *
     * @param NotifikaceObjVO 
     * @return cz.marbes.cgo.controller.vo.NotifikaceObjVO
     */
    static createNotifikaceObj(NotifikaceObjVO) {
        const uri = serverContextPath + `/api/cgo/notifikace/objednavka`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, NotifikaceObjVO, headers));
    }

    /**
     * 
     *
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.NotifikaceObjVO>
     */
    static getNotifikaceObj(neaktivni) {
        const uri = serverContextPath + `/api/cgo/notifikace/objednavka`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return java.util.List<cz.marbes.cgo.controller.vo.NotifikaceHelpVO>
     */
    static getNotifikaceObjHelp() {
        const uri = serverContextPath + `/api/cgo/notifikace/objednavka/help`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param NotifikaceObjVO 
     * @param notifikaceObjId 
     * @return cz.marbes.cgo.controller.vo.NotifikaceObjVO
     */
    static updateNotifikaceObj(NotifikaceObjVO, notifikaceObjId) {
        const uri = serverContextPath + `/api/cgo/notifikace/objednavka/${notifikaceObjId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, NotifikaceObjVO, headers));
    }

    /**
     * 
     *
     * @param notifikaceObjId 
     * @return cz.marbes.cgo.controller.vo.NotifikaceObjVO
     */
    static getNotifikaceObjById(notifikaceObjId) {
        const uri = serverContextPath + `/api/cgo/notifikace/objednavka/${notifikaceObjId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
